import { render, staticRenderFns } from "./advantage.vue?vue&type=template&id=66cf83ae&scoped=true&"
import script from "./advantage.vue?vue&type=script&lang=js&"
export * from "./advantage.vue?vue&type=script&lang=js&"
import style0 from "./advantage.vue?vue&type=style&index=0&id=66cf83ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cf83ae",
  null
  
)

export default component.exports